import { Molecule, wrap, Wrapper } from "AppReact";
import styled from "styled-components";
import { Icon, SecondaryTextXl, SecondaryText2xlBold, SecondaryTextSm, SecondaryTextSmBold } from "atoms";
import { Mt1, Mt8 } from "wrappers";
import { ThinkingEmojiSvg } from "components/icons";
import getIsMobile from "components/atoms/utils/getIsMobile";
import { GenericWrapper, TextCenterWrapper, FlexCenterJustifyCenterWrapper } from "wrappers";
import { Button } from "./atoms";

const isMobile = getIsMobile();

const template = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Icon,
      name: "Icon",
      displayValue: ({}) => ThinkingEmojiSvg({}),
    },
    {
      wrapper: GenericWrapper,
      name: "Wrapper",
      atoms: [
        {
          component: isMobile
            ? wrap(wrap(SecondaryTextSmBold, TextCenterWrapper), Mt8)
            : wrap(wrap(SecondaryText2xlBold, TextCenterWrapper), Mt8),
          name: "PrimayText",
          displayValue: ({ primayText }) => primayText ?? `No results to see .`,
        },
        {
          wrapper: FlexCenterJustifyCenterWrapper,
          name: "Wrapper",
          atoms: [
            {
              component: wrap(Button, Wrapper(styled.div`margin-right: 10px;`)),
              name: "TextButton",
              renderIf: ({ actionText }) => !!actionText,
              displayValue: ({ actionText }) => actionText || "",
              displayState: ({ disabled, small, color = "#1DBD6B" }) => {
                const fontSize = isMobile ? '14px' : '24px';
                return { fontWeight: '400', small, disabled, fontSize, color }
              },
            },
            {
              component: isMobile
                ? wrap(wrap(SecondaryTextSm, TextCenterWrapper), Mt1)
                : wrap(wrap(SecondaryTextXl, TextCenterWrapper), Mt1),
              name: "SecondaryText",
              displayValue: ({ secondaryText }) => secondaryText ?? "",
            },
          ],
        },
      ],
    },
  ],
});
